import React from 'react'
import { Title } from '@devexpress/dx-react-chart-material-ui'
import { useStyles } from './styles'
import Help from '@material-ui/icons/Help'

const titleStyle = { margin: 'auto' }
const TitleText = props => {
  const classes = useStyles()
  return (
    <div className={classes.titleContainer}>
      <div className={classes.text}>
        <Title.Text {...props} style={titleStyle} />
      </div>
      <div className={classes.icon}>
        <Help
          viewBox='0 0 26 26'
          titleAccess='This chart shows where your learners are in the learning sequence. Each bar is a Step. Colors represent levels. Dotted lines reflect intended pace - green is on pace, yellow is behind.'
        />
      </div>
    </div>
  )
}

export default TitleText
